import fetchTBTSignings from '../Services/fetchTBTSignings'

export default () => (dispatch, getState) => {
  const { searchTerm, filters, pagination } = getState().screens.TBTSigning
  
  dispatch(fetchTBTSignings({
    search: searchTerm,
    filters,
    page: 1, // Reset to first page on search
    per_page: pagination.pageSize,
  }))
}
